import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import { useBoolean } from '@fluentui/react-hooks';
import { Col, Row } from 'react-bootstrap';
import { useGetListGapActions } from '../../../../../../hooks/services/sKPI/useOfGAP';
import GapActionCard from '../GapActionCard/GapActionCard';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { Toggle } from '@fluentui/react';
import { enum__ActionStatus, enum__RevisionStatus, __MessageTypes } from '../../../../../../common/Dictionaries';
import { isNullOrEmpty, showMessage } from '../../../../../../common/Helpers';
import { updateGapRevisionStatus } from '../../../../../../services/sKPI/gap.service';
import CLabel from '../../../../../Common/CLabel';

const SidePanelViewAllAction = (props) => {
    const { t } = useTranslation();

    const inputParam_EditMode = props.inputParam_EditMode !== null && props.inputParam_EditMode !== undefined ? props.inputParam_EditMode : false;
    const inputParam_SelectedRevisionStatusId = props.inputParam_SelectedRevisionStatusId !== null && props.inputParam_SelectedRevisionStatusId !== undefined ? props.inputParam_SelectedRevisionStatusId : false;
    const inputParam_GapRevisionsList = props.inputParam_GapRevisionsList !== null && props.inputParam_GapRevisionsList !== undefined ? props.inputParam_GapRevisionsList : null;
    const inputParam_SetGapRevisionsList = props.setGapRevisionsList !== null && props.setGapRevisionsList !== undefined ? props.setGapRevisionsList : null;
    
    const inputParam_GapAnalyzeId = props.inputParam_GapAnalyzeId;
    const inputParam_GapElementId = props.inputParam_GapElementId;
    const inputParam_GapRevisionId = props.inputParam_GapRevisionId;
    const inputParam_IsPanelOpen = props.inputParam_IsPanelOpen;
    const inputParam_SetterIsPanelOpen = props.inputParam_SetterIsPanelOpen;
    const inputParam_DataserieValueChartSelected = props.inputParam_DataserieValueChartSelected !== null && props.inputParam_DataserieValueChartSelected !== undefined ? props.inputParam_DataserieValueChartSelected : null;
        
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    const [hideProcessButton, setHideProcessButton] = useState(false);
    const [actionList, setActionList] = useState(__OBJECT_STRUCTURE_GetList());
    const [actionListFiltred, setActionListFiltred] = useState([]);
    useGetListGapActions(
        inputParam_GapAnalyzeId,
        null,
        (inputParam_DataserieValueChartSelected !== null ? null : inputParam_GapRevisionId),
        null,
        (inputParam_DataserieValueChartSelected !== null ? inputParam_DataserieValueChartSelected.id : null ),
        null,
        null,
        actionList,
        setActionList,
        inputParam_IsPanelOpen
    )

    const onSwitchShowActionsWithProblems = (forceOn = false) => {
            switch (inputParam_SelectedRevisionStatusId) {
                case enum__RevisionStatus.GAP_REVISION:
                    setActionListFiltred(actionList.data.filter(x => isNullOrEmpty(x.title) ||  isNullOrEmpty(x.action) ||  isNullOrEmpty(x.beginDate) || isNullOrEmpty(x.endDate) || isNullOrEmpty(x.owner) || isNullOrEmpty(x.executor)));
                    
                    break;
                case enum__RevisionStatus.GAP_REVISION_ANALYZE:
                    setActionListFiltred(actionList.data.filter(x =>x.statusId !== enum__ActionStatus.GAP_ACTION_PENDING &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_CANCELED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED_UNVALIDATED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED)
                    );
                    break;
                case enum__RevisionStatus.GAP_REVISION_DIALOGUE:
                    setActionListFiltred(actionList.data.filter(x =>x.statusId !== enum__ActionStatus.GAP_ACTION_ENGAGED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_PENDING &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_CANCELED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED_UNVALIDATED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED)
                    );
                    break;
                case enum__RevisionStatus.GAP_REVISION_REVISION:
                    setActionListFiltred(actionList.data.filter(x =>x.statusId !== enum__ActionStatus.GAP_ACTION_ENGAGED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_PENDING &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_CANCELED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED_UNVALIDATED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED)
                    );
                    break;
                case enum__RevisionStatus.GAP_REVISION_END:
                    setActionListFiltred(actionList.data.filter(x =>x.statusId !== enum__ActionStatus.GAP_ACTION_ENGAGED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_PENDING &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_CANCELED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED_UNVALIDATED &&
                                                                    x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED)
                    );
                    break;
                default:
                    break;
            }
    };

    const _onSwitchShowActionsWithProblems = () => {
        onSwitchShowActionsWithProblems()
    };

    const validateForm = () => {
        let isValid = false;
        let newStatusId = inputParam_SelectedRevisionStatusId;
        let messageKeyword = "";
        const actions_total = actionList.data.length;
        let actions_ok = 0;

        if (actionList.data.length > 0) {
            switch (inputParam_SelectedRevisionStatusId) {
                case enum__RevisionStatus.GAP_REVISION:
                    isValid = actionList.data.filter(x => x.statusId >= enum__ActionStatus.GAP_ACTION).length > 0
                    isValid = isValid ? (inputParam_GapRevisionsList.length > 0) : isValid;
                    
                    if (!isValid) { messageKeyword = 'data-lang-msg-processgap-error-1to2' }
                    else { newStatusId = enum__RevisionStatus.GAP_REVISION_ANALYZE }
                    break;
                case enum__RevisionStatus.GAP_REVISION_ANALYZE:
                    actions_ok = actionList.data.filter(x => x.statusId >= enum__ActionStatus.GAP_ACTION_ENGAGED).length
                    
                    isValid = actions_ok === actions_total
                    
                    if (!isValid) { messageKeyword = 'data-lang-msg-processgap-error-1to2' }
                    else { newStatusId = enum__RevisionStatus.GAP_REVISION_DIALOGUE }
                    break;
                case enum__RevisionStatus.GAP_REVISION_DIALOGUE:
                    actions_ok = actionList.data.filter(x => x.statusId >= enum__ActionStatus.GAP_ACTION_ENGAGED).length

                    isValid = actions_ok === actions_total

                    if (!isValid) { messageKeyword = 'data-lang-msg-processgap-error-2to3' }
                    else { newStatusId = enum__RevisionStatus.GAP_REVISION_REVISION }
                    break;
                case enum__RevisionStatus.GAP_REVISION_REVISION:
                    actions_ok = actionList.data.filter(x => x.statusId >= enum__ActionStatus.GAP_ACTION_COMPLETED).length

                    isValid = actions_ok === actions_total

                    if (!isValid) { messageKeyword = 'data-lang-msg-processgap-error-3to4' }
                    else { newStatusId = enum__RevisionStatus.GAP_REVISION_END }
                    break;
                case enum__RevisionStatus.GAP_REVISION_END:
                    actions_ok = actionList.data.filter(x => x.statusId >= enum__ActionStatus.GAP_ACTION_COMPLETED).length

                    isValid = actions_ok === actions_total

                    if (!isValid) { messageKeyword = 'data-lang-msg-processgap-error-4to5' }
                    else { newStatusId = enum__RevisionStatus.GAP_REVISION_END }
                    break;
                default:
                    newStatusId = inputParam_SelectedRevisionStatusId;
                    break;
            }
        }
        else {
            messageKeyword = 'data-lang-msg-processgap-error-noactions'
        }

        return { isValid, newStatusId, message: messageKeyword };
    };

    const onProcessRevisionClick = () => {
        let isValidForm = validateForm();
        
        if (isValidForm.isValid) {
            updateGapRevisionStatus(inputParam_GapRevisionId, isValidForm.newStatusId).then((response) => {
                if (response.data.succeeded) {
                    inputParam_GapRevisionsList.forEach(revision => {
                        if (revision.id === inputParam_GapRevisionId) {
                            revision.statusId = revision.statusId + 1;
                        }
                    });
                    inputParam_SetGapRevisionsList && inputParam_SetGapRevisionsList(prevState => ({
                        ...prevState,
                        data : inputParam_GapRevisionsList
                    }))
                    setHideProcessButton(true)
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            onSwitchShowActionsWithProblems(true);
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t(isValidForm.message))
        }
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
        setActionListFiltred([]);
        setHideProcessButton(false);
        showMessage(setMessageConfig, false, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
        setActionList(__OBJECT_STRUCTURE_GetList());
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div>
            {
                inputParam_EditMode && !hideProcessButton &&
                <PrimaryButton onClick={ onProcessRevisionClick } styles={ _global_buttonStyles }>{ t('data-lang-btn-processrevision') }</PrimaryButton>
            }
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ inputParam_EditMode ? t('data-lang-boxname-processrevision') : t('data-lang-boxname-actionlist') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >    
                {
                    inputParam_EditMode &&
                    <>
                        <Row className="mb-3">
                            <Col className="pt-3">
                                <CLabel labelText={t('data-lang-lbl-status')} labelValue={t('data-lang-skrevision-status' + inputParam_SelectedRevisionStatusId)} />
                            </Col>
                        </Row>
                        <Row style={{backgroundColor: "#dddddd", fontSize: "16px"}}>
                            <Col>
                                <CLabel labelText={t('data-lang-lbl-actions')} />
                            </Col>
                        </Row>
                    </>
                    
                }
                {
                    !inputParam_EditMode &&
                    <Row>
                        <Col>
                            <CLabel labelText={t('data-lang-lbl-status')} valueText={t('data-lang-skrevision-status' + inputParam_SelectedRevisionStatusId)} />
                        </Col>
                    </Row>
                }
                <Row className='h-95'>
                    <Col className='h-100' style={{overflow: "scroll"}}>
                    {
                        actionList && actionList.data && actionList.data.map((item, index) => {
                            return  <Row key={item.id} className={`border-bottom border-top ${actionListFiltred.some(x => x.id === item.id) ? 'error-action' : ''}`}>
                                        <Col>
                                            <GapActionCard
                                                inputParam_EditMode={false}
                                                inputParam_GapElementId={inputParam_GapElementId}
                                                inputParam_ActionItem={item}
                                                inputParam_ShowSeparatorStyle={false}
                                                inputParam_SetterActionList={setActionList}
                                                inputParam_ShowCause={true}
                                                inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                                inputParam_GapRevisionId={inputParam_GapRevisionId}
                                                inputParam_InvertClass={false}
                                                inputParam_Dflex_Buttons={true}
                                            />
                                        </Col>
                                    </Row>
                        })
                    }
                    </Col>
                </Row>
                {
                    inputParam_EditMode &&
                    <Row>
                        <Col className='message-verybottom-panel-medium-message' style={{bottom: inputParam_EditMode ? "50px !important" : ""}} >
                            <MessageBox
                                inputParam_Width="96%" 
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                            />
                        </Col>
                    </Row>  
                }
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelViewAllAction;